<script setup lang="ts">
import { CoButton } from '@deputy/copilot2';
import ProfilePicture from './ProfilePicture.vue';
import LogOut from './icons/LogOut.vue';
import { getTranslations } from '@/lib/util/i18n';
import { useUserStore } from '@/stores/user';

import router from '@/router';
const user = useUserStore();
const logout = () => {
  user.logout();
  router.push({ name: 'home' });
};

const t = getTranslations({
  app: '',
  module: 'views',
  file: 'navigation-bar',
});
</script>

<template>
  <div class="__profile-container">
    <ProfilePicture
      v-if="user.data.activeUser"
      :src="user.data.activeUser.Photo"
      alt="Profile Picture"
    />
    <CoButton
      v-if="user.data.activeUser"
      @click="logout"
      size="large"
      data-test-id="logout"
    >
      <div class="__logout-container">
        <LogOut />
        <span>{{ t('log-out') }}</span>
      </div>
    </CoButton>
  </div>
</template>

<style scoped>
.__profile-container {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  justify-content: flex-end;
}

.__logout-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
}
</style>
